module.exports = __webpack_public_path__ + "static/media/cp-logo.64e3681c.png";